import { Button, Modal } from '@dev-spendesk/grapes';
import { type Dispatch, type SetStateAction } from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  onDelete: () => void;
  numberOfRulesToBeDeleted: number;
}

export const PayableRuleDeleteConfirmationModal = ({
  isOpen,
  setIsOpen,
  onDelete,
  numberOfRulesToBeDeleted,
}: Props) => {
  const { t } = useTranslation('global');

  const modalTitle = t(
    'bookkeep.integrations.settings.payableRules.details.deleteModalTitle',
    { count: numberOfRulesToBeDeleted },
  );
  const modalSubtitle = t(
    'bookkeep.integrations.settings.payableRules.details.deleteModalSubtitle',
    { count: numberOfRulesToBeDeleted },
  );

  return (
    <Modal
      title={modalTitle}
      subtitle={modalSubtitle}
      isOpen={isOpen}
      iconVariant="alert"
      iconName="hexagone-cross"
      actions={[
        <Button
          autoFocus
          key="cancel"
          onClick={() => setIsOpen(false)}
          text={t('misc.cancel')}
          variant="secondaryNeutral"
        />,
        <Button
          key="yes"
          onClick={() => {
            if (isOpen) {
              onDelete();
            }

            setIsOpen(false);
          }}
          text={t('misc.delete')}
          variant="primaryAlert"
        />,
      ]}
    />
  );
};
